import { mapState, mapStores } from 'pinia';
import { defineComponent } from 'vue';
import moment, { Moment } from 'moment';
import { NDivider, NList, NListItem, NSpin } from 'naive-ui';

import { useStationStore } from '~/store/station.store';
import { DashboardSlots } from '~/api/models/dashboard/dashboard-history.model';
import { Station } from '~/api/models/station.model';

import ModalBase from '~/components/modals/modal-base';
import DeviceListItem from '~/components/device-list-item/device-list-item.vue';

import { AvoltaTemperatureIndicator, AvoltaHumidityIndicator } from '~/configs/indicators/avolta-indicators.config';
import { useDashboardStore } from '~/store/dashboard.store';



export default defineComponent({

    extends: ModalBase,

    components: {
        NSpin,
        NList,
        NListItem,
        NDivider,
        DeviceListItem,
    },

    data() {
        return {
            slot: null as DashboardSlots,
            mode: null as 'connection' | 'alarm',
            AvoltaTemperatureIndicator,
            AvoltaHumidityIndicator,
            loading: true,
            progression: 0,
            gasDevices: [],
            troubleDevices: [],
            okDevices: [],
            onlineDevices: [],
            offlineDevices: [],
        }
    },

    computed: {
        ...mapStores(useStationStore),
        ...mapState(useStationStore, ['stations']),
        ...mapState(useDashboardStore, ['since', 'before']),

        dateFormat(): string {
            if (this.start.diff(this.end, 'days') < 1) {
                return 'lll'
            } else {
                return 'll';
            }
        },

        start(): Moment {
            return moment.unix(this.slot.start);
        },

        end(): Moment {
            return moment.unix(this.slot.end);
        },

        // async gasDevices(): Promise<Station[]> {
        //     return Promise.all(this?.slot?.gas?.map(async (id: string) => this.getStation(id)));
        // },

        // troubleDevices(): Station[] {
        //     return this?.slot?.trouble?.map(id => this.stations.find(s => s?.id === id)).filter(s => s) || [];
        // },

        // okDevices(): Station[] {
        //     return this?.slot?.ok?.map(id => this.stations.find(s => s?.id === id)).filter(s => s) || [];
        // },

        // onlineDevices(): Station[] {
        //     return this?.slot?.online?.map(id => this.stations.find(s => s?.id === id)).filter(s => s) || [];
        // },

        // offlineDevices(): Station[] {
        //     return this?.slot?.offline?.map(id => this.stations.find(s => s?.id === id)).filter(s => s) || [];
        // },
    },

    methods: {
        async open(slot: DashboardSlots, mode: 'alarm' | 'connection') {
            this.slot = slot;
            this.mode = mode;
            this.loading = false;

            this.gasDevices = await Promise.all(slot.gas.map(id => this.getStation(id)));
            this.troubleDevices = await Promise.all(slot.trouble.map(id => this.getStation(id)));
            this.okDevices = await Promise.all(slot.ok.map(id => this.getStation(id)));
            this.onlineDevices = await Promise.all(slot.online.map(id => this.getStation(id)));
            this.offlineDevices = await Promise.all(slot.offline.map(id => this.getStation(id)));

            this.$refs?.modal?.open();

        },

        async getStation(id: string): Promise<Station> {
            const station: Station = this.stations.find(device => device?.id === id);

            if(station) {
                return Promise.resolve(station);
            }

            try {
                return this.$stationService.getStationDetails(id);
            } catch(error) {
                return null;
            }
        }
    },
});